import { useCallback } from "react";
import { useRouterContext } from "../../providers/RouterProvider";

export interface UseModuleRouterResult {
  readonly selectedId: string | undefined;
  readonly setSelectedId: (id: string | undefined) => void;
}

/**
 * URL sync hook for BaseModule.
 * Reads entityId from router when this module is active.
 * Writes selection back to URL as #/{moduleId}/{primaryEntityType}/{entityId}.
 */
export function useModuleRouter(
  moduleId: string,
  primaryEntityType: string,
): UseModuleRouterResult {
  const router = useRouterContext();

  const selectedId =
    router.activeModuleId === moduleId ? router.entityId : undefined;

  const setSelectedId = useCallback(
    (id: string | undefined) => {
      router.setSelection(primaryEntityType, id);
    },
    [router, primaryEntityType],
  );

  return { selectedId, setSelectedId };
}
